import axios from "axios";
import type { GetServerSideProps, InferGetServerSidePropsType } from "next";

import { BreadCrumb } from "@/components/BreadCrumb";
import type { GetCategoryDto } from "@/entities/types/entities";
import { PageLayout } from "@/layouts/PageLayout";
import Build from "@/shared/assests/build.webp";
import { API_BASE } from "@/shared/constants/private";
import { BuildingPage } from "@/view/Building/Building";

const advertisingOptions = [
    "рекламавлифтах",
    "рекламанавидеоэкранах",
    "размещениевподъездах",
    "дорхенгеры",
    "квитанции",
    "почтовыеящики",
];

export default function Building({ sectionId, sectionNumber, cat }: InferGetServerSidePropsType<typeof getServerSideProps>) {
    const items = [{ label: "Реклама в жилых домах" }];
    const sortCategoriesByPriority = (categories: GetCategoryDto[], priorities: string[]) => {
        return categories.sort((a, b) => {
            const formattedTitleA = a.title.toLowerCase().replace(/\s/g, "");
            const formattedTitleB = b.title.toLowerCase().replace(/\s/g, "");
            const priorityA = priorities.indexOf(formattedTitleA);
            const priorityB = priorities.indexOf(formattedTitleB);

            if (priorityA !== -1 && priorityB !== -1) {
                return priorityA - priorityB;
            }

            if (priorityA !== -1) {
                return -1;
            }

            if (priorityB !== -1) {
                return 1;
            }

            return 0;
        });
    };
    const sortedCategories = sortCategoriesByPriority(cat, advertisingOptions);

    return (
        <PageLayout
            title="Реклама в ЖК и новостройках | Размещение в жилых домах СПб"
            description="Эффективная реклама в ЖК, новостройках и элитных жилых комплексах. Digital-экраны,стенды, дорхенгеры, вложения в квитанции в Санкт-Петербурге. Полный цикл услуг!"
            page_type="service"
        >
            <BreadCrumb model={items} />
            <BuildingPage
                listCategory={sortedCategories}
                sectionId={sectionId}
                sectionNumber={sectionNumber}
                alt="Build"
                src={Build}
                title="Реклама в жилых домах"
                description="Реклама в жилых домах — это возможность быть на виду у клиентов каждый
                            день! Ваше сообщение встречает жителей, когда они выходят из дома или
                            возвращаются с работы: это часть их повседневной жизни. Именно ваша
                            реклама станет тем самым «щелчком», который заставит их обратиться к вам"
            />
        </PageLayout>
    );
}

export const getServerSideProps: GetServerSideProps = async () => {
    const sectionId = "6260e70c-5ac5-4faf-aef8-911046373811";
    const sectionNumber = 1;

    const resCat = await axios<GetCategoryDto[]>(`${API_BASE}/category`, {
        params: { sectionId: sectionId, onlyPublished: true } }).catch(() => ({ data: [] }));

    return {
        props: {
            sectionId: sectionId,
            sectionNumber: sectionNumber,
            cat: resCat.data,
        },
    };
};
